import React from 'react';

class MBI extends React.Component {
    constructor(props) {
        super(props);
        const mbiFormat = ['C', 'A', 'AN', 'N', 'A', 'AN', 'N', 'A', 'A', 'N', 'N'];

        const mbiGenerators = {
            C: Array.from({ length: 9 }, (_, i) => (i + 1).toString()),
            N: Array.from({ length: 10 }, (_, i) => i.toString()),
            A: Array.from('ABCDEFGHJKMNPQRTUVWXY'),
            AN: Array.from('ABCDEFGHJKMNPQRTUVWXY').concat(Array.from({ length: 10 }, (_, i) => i.toString())),
        };

        this.state = {
            mbi: this.generateMBI(mbiFormat, mbiGenerators),
        };

        this.mbiFormat = mbiFormat;
        this.mbiGenerators = mbiGenerators;
    }

    generateMBI = (format, generators) => {
        return format.map((c) => {
            const options = generators[c];
            return options[Math.floor(Math.random() * options.length)];
        }).join('');
    };

    regenerateMBI = () => {
        this.setState({
            mbi: this.generateMBI(this.mbiFormat, this.mbiGenerators),
        });
    };

    render() {
        return (
            <section className="mbi-generator" aria-labelledby="generated-mbi-heading">
                <h2 id="generated-mbi-heading">Generated MBI</h2>
                <p className="mbi-value">{this.state.mbi}</p>
                <button onClick={this.regenerateMBI}>
                    Generate New MBI
                </button>
            </section>
        );
    }
}

export default MBI;
